import React from 'react';
import { getDeviationType } from '../_helpers';
import LoadingIndicator from '../../LoadingIndicator';
import { DeviationTypes } from '../../types/deviation';
import MediaService from '../../utils/DeviationMediaService';
class PollForThumbReady extends React.Component {
    componentDidMount() {
        const type = getDeviationType(this.props.deviation);
        if (type !== DeviationTypes.IMAGE) {
            // TODO only wait for images???
            return this.setState({
                ready: true
            });
        }
        this.checkThumbs();
    }
    componentWillUnmount() {
        clearTimeout(this.checkTimeout);
    }
    checkThumbs() {
        const thumbs = MediaService.getThumbSet(this.props.deviation);
        const promises = thumbs.filter((th)=>th.type === '150' || th.type === '200T').map((th)=>ImagePromise(th.src));
        Promise.all(promises).then((results)=>{
            const allFinished = results.filter((r)=>r.ready !== true);
            if (allFinished.length === 0) {
                this.setState({
                    ready: true
                });
                return;
            }
            this.checkTimeout = setTimeout(this.checkThumbs.bind(this), 3500);
        });
    }
    render() {
        if (!this.state.ready) {
            return /*#__PURE__*/ React.createElement(LoadingIndicator, null);
        }
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            ready: false
        };
    }
}
/**
 * This was quick fix, we probably want this to happen inside the dumbo
 * views so we know the correct thumb to check etc. Attaching to the actual
 * img tag would be good but we use bg images so dont think that will work.
 */ export { PollForThumbReady as default };
function ImagePromise(src) {
    return new Promise((resolve, reject)=>{
        const checkImg = new Image();
        checkImg.addEventListener('load', doneReady);
        checkImg.addEventListener('error', doneErr);
        checkImg.src = src;
        function doneReady() {
            resolve({
                ready: true
            });
            checkImg.removeEventListener('load', doneReady);
            checkImg.removeEventListener('error', doneErr);
        }
        function doneErr() {
            resolve({
                ready: false
            });
        }
    });
}
